import APIService from '../api.service';

export const List = (params) => {
  return APIService.get(`/v01/categories`, {
    params: {
      per_page: params.perPage,
      page: params.page,
      keyword: params.keyword,
    },
  });
};

export const DropdownList = () => {
  return APIService.get(`/v01/categories/dropdown`);
};

export const Create = (body, config = {}) => {
  return APIService.post(`/v01/categories`, body, config);
};

export const Put = (payload, config = {}) => {
  const { id } = payload;
  return APIService.put(`/v01/categories/${id}`, {...payload}, config);
};

export const Delt = (id, config = {}) => {
  return APIService.delete(`/v01/categories/${id}`, config);
};

const CategoryService = {
  List,
  DropdownList,
  Create,
  Put,
  Delt,
};
export default CategoryService;
